export default __webpack_public_path__ + "static/media/price-list.d03fba2f.svg";